(function () {
  'use strict';

  angular.module('ringbaPortal').component('offerOverview', {
    bindings: {
      overviewOffer: '<',
      isDraft: '<'
    },
    controller: OfferOverviewController,
    controllerAs: 'vm',
    templateUrl: '/scripts/components/offer/offer-overview/offer-overview.view.html'
  });

  function OfferOverviewController(
    accountsService,
    infoService,
    moment
  ) {
    'ngInject';

    const vm = this;
    let supportedLanguagesOptions = [];

    vm.$onInit = onInit;
    vm.$onChanges = onChanges;

    function onInit() {
      vm.isAffiliate = accountsService.isAffiliate();
    }

    function onChanges() {
      if (vm.overviewOffer) {
        _loadLanguages();
        vm.expiration = vm.isDraft && vm.overviewOffer.expiration ? moment(vm.overviewOffer.expiration).format('D MMM YYYY, hh:mm A') : null;
      }
    }

    function _loadLanguages() {
      infoService.getOfferSupportedLanguages().then(function (response) {
        supportedLanguagesOptions = response.data;
        _setLanguagesSelectedArray(supportedLanguagesOptions);
      });
    }

    function _setLanguagesSelectedArray(allLanguages) {
      vm.selectedLanguages = _.map(vm.overviewOffer.languageCodes, function(code) {
        return _.find(allLanguages, { code: code }).name;
      });
    }

  }
})();
